<template>
  <el-form class="form">
    <el-row :gutter="5">
      <el-col :xs="24" :sm="16" :md="12" :lg="8" :xl="6">
        <el-form-item :label="$t('cpf/cnpj')" prop="federalid" class="is-required">
          <el-input v-model="ruleForm.federalid" ref="federalid"
            v-mask="['NNN.NNN.NNN-NN', 'NN.NNN.NNN/NNNN-##']"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="16" :xl="12">
        <el-form-item :label="$t('nome')" prop="federalid" class="is-required">
          <el-input v-model="ruleForm.name" ref="name"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="24" :sm="16" :md="12" :lg="6" :xl="6">
        <el-form-item :label="$t('telefone')" prop="phone" class="is-required">
          <el-input maxlength="16" v-model="ruleForm.phone" ref="phone"
            v-mask="['(##) ####-####', '(##) #####-####']"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="14" :sm="6" :md="6" :lg="6" :xl="6" v-if="type === 'pix'">
        <el-form-item :label="$t('email')" prop="mail" class="is-required">
          <el-input maxlength="120" v-model="ruleForm.mail" ref="mail"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="14" :sm="6" :md="6" :lg="6" :xl="6" v-else>
        <el-form-item :label="$t('cep')" prop="cep" class="is-required">
          <el-input maxlength="9" v-model="ruleForm.cep" v-mask="'#####-###'" ref="cep" @blur="zipcode()"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5" v-if="type !== 'pix'">
      <el-col :xs="24" :sm="12" :md="12" :lg="14" :xl="12">
        <el-form-item :label="$t('endereco')" prop="address" class="is-required">
          <el-input v-model="ruleForm.address" ref="address"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5" v-if="type !== 'pix'">
      <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
        <el-form-item :label="$t('bairro')" prop="neighborhood" class="is-required">
          <el-input v-model="ruleForm.neighborhood" ref="neighborhood"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="6">
        <el-form-item :label="$t('cidade')" prop="city" class="is-required">
          <el-input v-model="ruleForm.city" ref="city"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6" :lg="4" :xl="3">
        <el-form-item :label="$t('estado')" prop="state" class="is-required">
          <el-select v-model="ruleForm.state" filterable ref="state">
            <el-option key="AC" label="Acre" value="AC"></el-option>
            <el-option key="AL" label="Alagoas" value="AL"></el-option>
            <el-option key="AP" label="Amapá" value="AP"></el-option>
            <el-option key="AM" label="Amazonas" value="AM"></el-option>
            <el-option key="BA" label="Bahia" value="BA"></el-option>
            <el-option key="CE" label="Ceará" value="CE"></el-option>
            <el-option key="DF" label="Distrito Federal" value="DF"></el-option>
            <el-option key="ES" label="Espírito Santo" value="ES"></el-option>
            <el-option key="GO" label="Goiás" value="GO"></el-option>
            <el-option key="MA" label="Maranhão" value="MA"></el-option>
            <el-option key="MT" label="Mato Grosso" value="MT"></el-option>
            <el-option key="MS" label="Mato Grosso do Sul" value="MS"></el-option>
            <el-option key="MG" label="Minas Gerais" value="MG"></el-option>
            <el-option key="PA" label="Pará" value="PA"></el-option>
            <el-option key="PB" label="Paraíba" value="PB"></el-option>
            <el-option key="PR" label="Paraná" value="PR"></el-option>
            <el-option key="PE" label="Pernambuco" value="PE"></el-option>
            <el-option key="PI" label="Piauí" value="PI"></el-option>
            <el-option key="RJ" label="Rio de Janeiro" value="RJ"></el-option>
            <el-option key="RN" label="Rio Grande do Norte" value="RN"></el-option>
            <el-option key="RS" label="Rio Grande do Sul" value="RS"></el-option>
            <el-option key="RO" label="Rondônia" value="RO"></el-option>
            <el-option key="RR" label="Roraima" value="RR"></el-option>
            <el-option key="SC" label="Santa Catarina" value="SC"></el-option>
            <el-option key="SP" label="São Paulo" value="SP"></el-option>
            <el-option key="SE" label="Sergipe" value="SE"></el-option>
            <el-option key="TO" label="Tocantins" value="TO"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5" v-if="type !== 'pix'">
      <el-col :xs="24" :sm="16" :md="12" :lg="6" :xl="6">
        <el-form-item :label="$t('numero')" prop="number">
          <el-input type="number" maxlength="6" ref="number" v-model="ruleForm.number"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="16" :md="12" :lg="14" :xl="6">
        <el-form-item :label="$t('complemento')" prop="extent">
          <el-input v-model="ruleForm.extent" ref="extent" maxlength="255"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { UserService } from "@/services/users/user.services";
import ZipMixins from "../../../../mixins/zipcode";
export default {
  name: 'PaymentComplement',
  mixins: [ZipMixins],
  props: ["data", 'type'],
  data() {
    return {
      ruleForm: {
        federalid: '',
        name: '',
        mail: '',
        cep: "",
        address: "",
        city: "",
        state: "",
        neighborhood: "",
        number: "",
        phone: "",
        extent: "",
      }
    }
  },
  methods: {
    setup(data) {
      console.log('data', data)
      this.ruleForm = data;
    },
    get() {
      return this.ruleForm;
    },
    test(tag, message) {
      const vm = this;
      if (!vm.ruleForm[tag]) {
        this.$message({
          type: "error",
          message: message,
        });
        vm.$refs[tag].$el.children[0].focus();
        return false;
      }
      return true;
    },
    validate() {
      if (this.type === 'pix') {
        return this.test('federalid', "CPF/CNPJ é obrigatório!")
          ? this.test('name', "Nome é obrigatório!")
            ? this.test('mail', "E-mail é obrigatório!")
            : false
          : false;

      } else {
        return this.test('federalid', "CPF/CNPJ é obrigatório!")
          ? this.test('name', "Nome é obrigatório!")
            ? this.test('cep', "CEP é obrigatório!")
              ? this.test('address', "Endereço é obrigatório!")
                ? this.test('city', "Cidade é obrigatório!")
                  ? this.test('state', "Estado é obrigatório!")
                    ? this.test('neighborhood', "Bairro é obrigatório!")
                      ? this.test('phone', "Telefone é obrigatório!")
                      : false
                    : false
                  : false
                : false
              : false
            : false
          : false;
      }
    }
  },
  mounted() {
    const vm = this;
    console.log(vm.data, vm.data.federalid)
    if (vm.data && vm.data.federalid) {
      vm.ruleForm.phone = vm.data.phone;
      vm.ruleForm.mail = vm.data.mail;
      vm.ruleForm.name = vm.data.name;
      vm.ruleForm.federalid = vm.data.federalid;
      vm.ruleForm.cep = vm.data.cep;
      vm.ruleForm.address = vm.data.address;
      vm.ruleForm.city = vm.data.city;
      vm.ruleForm.state = vm.data.state;
      vm.ruleForm.neighborhood = vm.data.neighborhood;
      vm.ruleForm.number = vm.data.number;
      vm.ruleForm.extent = vm.data.extent;
    } else {
      const loading = vm.$loading(vm.$options.loading);
      UserService.me()
        .then((user) => {
          console.log('user', user)
          vm.ruleForm.phone = user.customers ? user.customers.phone : '';
          vm.ruleForm.name = user.username;
          vm.ruleForm.mail = user.mail;
          vm.ruleForm.federalid = user.customers ? user.customers.federalid : '';
          vm.ruleForm.cep = user.customers ? user.customers.zipcode.zipcode : '';
          vm.ruleForm.address = user.customers ? user.customers.address || user.customers.zipcode.address : '';
          vm.ruleForm.city = user.customers ? user.customers.city || user.customers.zipcode.city : '';
          vm.ruleForm.state = user.customers ? user.customers.state || user.customers.zipcode.state : '';
          vm.ruleForm.neighborhood = user.customers ? user.customers.neighborhood || user.customers.zipcode.neighborhood : '';
          vm.ruleForm.number = user.customers ? user.customers.number : '';
          vm.ruleForm.extent = user.customers ? user.customers.extent : '';
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    }
  }
}
</script>

